import { IJackpotViewModel } from "../interfaces/eligibleJackpots.js";
import { IErrorPayload, IStatus } from "../interfaces/root.js";

export enum eligibleJackpotActionTypes {
  GET_ELIGIBLE_JACKPOTS_REQUEST = "GET_ELIGIBLE_JACKPOTS_REQUEST",
  GET_ELIGIBLE_JACKPOTS_SUCCESS = "GET_ELIGIBLE_JACKPOTS_SUCCESS",
  GET_ELIGIBLE_JACKPOTS_FAILURE = "GET_ELIGIBLE_JACKPOTS_FAILURE",

  UPDATE_JACKPOTS_DATA = "UPDATE_JACKPOTS_DATA",
  OPEN_JACKPOT_MODAL = "OPEN_JACKPOT_MODAL",
  CLOSE_JACKPOT_MODAL = "CLOSE_JACKPOT_MODAL",
}

export type GetEligibleJackpotsRequestAction = {
  type: eligibleJackpotActionTypes.GET_ELIGIBLE_JACKPOTS_REQUEST;
};

export type GetEligibleJackpotsSuccessAction = {
  type: eligibleJackpotActionTypes.GET_ELIGIBLE_JACKPOTS_SUCCESS;
  payload: IJackpotViewModel[];
};

export type GetEligibleJackpotsFailureAction = {
  type: eligibleJackpotActionTypes.GET_ELIGIBLE_JACKPOTS_FAILURE;
  payload: IErrorPayload;
};

export type UpdateJackpotsDataAction = {
  type: eligibleJackpotActionTypes.UPDATE_JACKPOTS_DATA;
  payload: IJackpotViewModel;
};

export type OpenJackpotModalAction = {
  type: eligibleJackpotActionTypes.OPEN_JACKPOT_MODAL;
};

export type CloseJackpotModalAction = {
  type: eligibleJackpotActionTypes.CLOSE_JACKPOT_MODAL;
};

export type eligibleJackpotsActions =
  | GetEligibleJackpotsRequestAction
  | GetEligibleJackpotsSuccessAction
  | GetEligibleJackpotsFailureAction
  | UpdateJackpotsDataAction
  | OpenJackpotModalAction
  | CloseJackpotModalAction;

export type EligibleJackpotsState = {
  pending: boolean;
  status: IStatus | null;
  jackpots: IJackpotViewModel[] | null;
  showJackpotModal: boolean;
};
